import { isNone } from '@ember/utils';

export default function moveElementInArray(arr, fromIndex, toIndex) {
  let copy = arr.slice();
  let lastIndex = copy.length - 1;

  if (toIndex > lastIndex) {
    toIndex = lastIndex;
  }

  let element = copy[fromIndex];

  if (isNone(element)) {
    return arr;
  }

  copy.splice(fromIndex, 1);
  copy.splice(toIndex, 0, element);

  return copy;
}
